<mat-form-field [ngClass]="(positionField === field && onBuilder) ? 'active-control' : ''">
    <input matInput [matDatepicker]="picker" placeholder="{{name}}"  (dateInput)="getValue($event)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>